/* eslint-disable react/prop-types */
import React from "react";
import Marquee from "../../components/marquee";
import { LandingTickerSection, LandingWideSection } from "./landing-section";

const arr = (checklist, i) => {
  const len = JSON.parse(checklist.films).length;
  const a = JSON.parse(checklist.films).slice(
    (i * len) / 2,
    (i * len) / 2 + len / 2
  );
  const titles = ["Umeed", "Faasle"];
  return a
    .filter((item) => !titles.includes(item.title))
    .map((item) => ({
      title: item.title,
      image: `https://img.airtel.tv/unsafe/fit-in/326x0/filters:format(webp)/https://image.airtel.tv/HUNGAMA/HUNGAMA_VIDEO_${item.link}/LANDSCAPE_169/${item.link}_1280x720.jpg?o=production${item.link}`,
    }));
};
const isMobileView = window.innerWidth < 768;

const Tickers = ({ checklist }) => {
  const hasPlatforms = Boolean(checklist.platforms);
  const hasTrending =
    Array.isArray(checklist.trending) && checklist.trending.length > 0;
  const filmsDivider = hasPlatforms || hasTrending;

  return (
    <>
      {hasPlatforms && (
        <LandingTickerSection
          title="Our Distribution Partners (OTT/Broadcast)"
          leadingDivider={false}
        >
          <Marquee images={checklist.platforms} width={150} margin={25} />
        </LandingTickerSection>
      )}
      {hasTrending && (
        <LandingTickerSection
          title="Trending on Black"
          leadingDivider={hasPlatforms}
        >
          <Marquee
            images={checklist.trending}
            width={300}
            margin={4}
            height={450}
            borderRadius="0px"
            background="transparent"
            animationSpeed={45}
          />
        </LandingTickerSection>
      )}
      {checklist.films && (
        <LandingWideSection
          title="500+ Short Films Released on Various Platforms"
          leadingDivider={filmsDivider}
        >
          <Marquee
            images={checklist.featured}
            width={isMobileView ? 194 : 254}
            margin={0}
            height={isMobileView ? 291 : 381}
            borderRadius="0px"
            reverse
          />
          <br />
          {Array.from({ length: 2 }).map((x, i) => (
            <React.Fragment key={i}>
              <Marquee
                images={arr(checklist, i)}
                width={200}
                margin={0}
                height={100}
                border="8px solid var(--vc-border)"
                borderRadius="8px"
                reverse={i === 1}
                background="transparent"
                animationSpeed={80}
              />
              {i !== 2 && <br />}
            </React.Fragment>
          ))}
        </LandingWideSection>
      )}
    </>
  );
};
export default Tickers;
